import React, { useEffect, useState } from 'react';
import {
  deletePayrollDiscountEntry,
  downloadPayrollDiscountReport,
  fetchPayrollDiscountEntries,
  fetchPayrollDiscounts,
  savePayrollDiscountEntry,
} from '../../services/adminService';
import { getUserDisplayName } from '../../services/authService';

const MESES = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' },
];

const dosDigitos = (valor) => String(valor).padStart(2, '0');

const periodoActual = () => {
  const hoy = new Date();
  const dia = hoy.getDate();
  const mes = dosDigitos(hoy.getMonth() + 1);
  const anio = String(hoy.getFullYear());

  return {
    quincena: dia <= 15 ? '1' : '2',
    mes,
    anio,
  };
};

const limitesFecha = () => {
  const periodo = periodoActual();

  if (periodo.quincena === '1') {
    return {
      min: periodo.anio + '-' + periodo.mes + '-01',
      max: periodo.anio + '-' + periodo.mes + '-15',
    };
  }

  const ultimo = new Date(Number(periodo.anio), Number(periodo.mes), 0).getDate();

  return {
    min: periodo.anio + '-' + periodo.mes + '-16',
    max: periodo.anio + '-' + periodo.mes + '-' + dosDigitos(ultimo),
  };
};

const fechaVisible = (fecha) => {
  const partes = String(fecha || '').split('-');
  if (partes.length !== 3) {
    return fecha;
  }
  return partes[2] + '/' + partes[1] + '/' + partes[0];
};

const aniosReporte = () => {
  const actual = new Date().getFullYear();
  const lista = [];
  for (let anio = actual - 2; anio <= actual + 1; anio += 1) {
    lista.push(String(anio));
  }
  return lista;
};

const NominaDescuentoHonorarios = ({ sessionId, personas, onSalir }) => {
  const periodo = periodoActual();
  const limites = limitesFecha();
  const [tipos, setTipos] = useState([]);
  const [empleadoId, setEmpleadoId] = useState('');
  const [horas, setHoras] = useState('');
  const [minutos, setMinutos] = useState('');
  const [dias, setDias] = useState('');
  const [fecha, setFecha] = useState('');
  const [fechas, setFechas] = useState([]);
  const [tipoId, setTipoId] = useState('');
  const [motivo, setMotivo] = useState('');
  const [reporteQuincena, setReporteQuincena] = useState(periodo.quincena);
  const [reporteMes, setReporteMes] = useState(periodo.mes);
  const [reporteAnio, setReporteAnio] = useState(periodo.anio);
  const [consultaEmpleadoId, setConsultaEmpleadoId] = useState('');
  const [registros, setRegistros] = useState([]);
  const [consultaAbierta, setConsultaAbierta] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');

  useEffect(() => {
    fetchPayrollDiscounts(sessionId)
      .then((lista) => {
        setTipos(lista);
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudieron cargar los tipos de descuento.');
      });
  }, [sessionId]);

  const tipo = tipos.find((item) => String(item.id) === String(tipoId));
  const esAusencia = Boolean(tipo && tipo.descripcion === 'AUSENCIA');
  const bloqueadoDias = horas !== '' || minutos !== '';
  const bloqueadoHoras = dias !== '';
  const textoQuincena = periodo.quincena === '1' ? 'Primera' : 'Segunda';

  const cambiarHoras = (event) => {
    const valor = event.target.value.replace(/\D/g, '').slice(0, 2);
    if (valor !== '' && parseInt(valor, 10) > 8) {
      return;
    }
    setHoras(valor);
    if (valor !== '' || minutos !== '') {
      setDias('');
    }
  };

  const cambiarMinutos = (event) => {
    const valor = event.target.value.replace(/\D/g, '').slice(0, 2);
    if (valor !== '' && parseInt(valor, 10) > 59) {
      return;
    }
    setMinutos(valor);
    if (valor !== '' || horas !== '') {
      setDias('');
    }
  };

  const cambiarDias = (event) => {
    const valor = event.target.value.replace(/\D/g, '');
    if (valor !== '' && valor !== '1') {
      return;
    }
    setDias(valor);
    if (valor !== '') {
      setHoras('');
      setMinutos('');
    }
  };

  const agregarFecha = () => {
    if (!fecha) {
      setError('Selecciona una fecha antes de agregarla.');
      setAviso('');
      return;
    }
    if (fecha < limites.min || fecha > limites.max) {
      setError('La fecha debe estar dentro de la quincena en curso.');
      setAviso('');
      return;
    }
    if (fechas.indexOf(fecha) >= 0) {
      setError('Esa fecha ya está en la lista.');
      setAviso('');
      return;
    }
    setFechas(fechas.concat(fecha).sort());
    setFecha('');
    setError('');
  };

  const guardar = () => {
    const fechasGuardar = fechas.slice();

    if (fechasGuardar.length === 0 && fecha && fecha >= limites.min && fecha <= limites.max) {
      fechasGuardar.push(fecha);
    }

    if (!empleadoId) {
      setError('Selecciona un empleado.');
      setAviso('');
      return;
    }
    if (fechasGuardar.length === 0) {
      setError('Agrega al menos una fecha de inasistencia.');
      setAviso('');
      return;
    }
    if (!tipoId) {
      setError('Selecciona el tipo de descuento.');
      setAviso('');
      return;
    }
    if (esAusencia && !motivo.trim()) {
      setError('Indica el motivo de la ausencia.');
      setAviso('');
      return;
    }
    if (!bloqueadoDias && !bloqueadoHoras) {
      setError('Indica horas y minutos a descontar, o días no trabajados.');
      setAviso('');
      return;
    }

    setGuardando(true);
    setError('');
    setAviso('');

    savePayrollDiscountEntry(sessionId, {
      usuario_id: Number(empleadoId),
      tipo_id: Number(tipoId),
      horas: bloqueadoHoras ? '' : horas,
      minutos: bloqueadoHoras ? '' : minutos,
      dias: bloqueadoHoras ? dias : '',
      motivo: esAusencia ? motivo.trim() : '',
      fechas: fechasGuardar,
    })
      .then((resultado) => {
        setAviso(resultado.message || 'Descuento guardado.');
        setConsultaEmpleadoId(empleadoId);
        setRegistros(resultado.registros || []);
        setConsultaAbierta(true);
        setEmpleadoId('');
        setHoras('');
        setMinutos('');
        setDias('');
        setFecha('');
        setFechas([]);
        setTipoId('');
        setMotivo('');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo guardar el descuento.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  const consultar = () => {
    if (!empleadoId) {
      return;
    }
    setError('');
    setAviso('');
    setConsultaEmpleadoId(empleadoId);
    fetchPayrollDiscountEntries(sessionId, Number(empleadoId))
      .then((lista) => {
        setRegistros(lista);
        setConsultaAbierta(true);
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudieron consultar los descuentos.');
      });
  };

  const eliminar = (id) => {
    if (!consultaEmpleadoId) {
      setError('Selecciona el empleado para eliminar el descuento.');
      return;
    }
    deletePayrollDiscountEntry(sessionId, Number(consultaEmpleadoId), id)
      .then((lista) => {
        setRegistros(lista);
        setAviso('Descuento eliminado.');
        setError('');
      })
      .catch((requestError) => {
        setError(requestError.message || 'No se pudo eliminar el descuento.');
      });
  };

  const reporte = () => {
    if (!reporteQuincena || !reporteMes || !reporteAnio) {
      setError('Selecciona quincena, mes y año para generar el reporte.');
      setAviso('');
      return;
    }
    setError('');
    downloadPayrollDiscountReport(sessionId, {
      quincena: reporteQuincena,
      mes: reporteMes,
      anio: reporteAnio,
    }).catch((requestError) => {
      setError(requestError.message || 'No se pudo generar el reporte.');
    });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-descuento-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Descuento honorarios</h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
        {error ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {error}
          </div>
        ) : null}
        {aviso ? (
          <div className="admin-alert admin-alert--success" role="status">
            {aviso}
          </div>
        ) : null}
        <div className="nomina-descuento-form">
          <label className="admin-field">
            <span>Empleado</span>
            <select value={empleadoId} onChange={(event) => setEmpleadoId(event.target.value)}>
              <option value="">Seleccione un empleado</option>
              {personas.map((persona) => (
                <option key={persona.id} value={persona.id}>
                  {getUserDisplayName(persona)}
                </option>
              ))}
            </select>
          </label>
          <div className="nomina-descuento-tiempo">
            <label className="admin-field">
              <span>Horas a descontar</span>
              <input
                value={horas}
                inputMode="numeric"
                maxLength={2}
                placeholder="Horas (máx. 8)"
                disabled={bloqueadoHoras}
                onChange={cambiarHoras}
              />
            </label>
            <span className="nomina-descuento-separador">:</span>
            <label className="admin-field">
              <span>Minutos</span>
              <input
                value={minutos}
                inputMode="numeric"
                maxLength={2}
                placeholder="Minutos"
                disabled={bloqueadoHoras}
                onChange={cambiarMinutos}
              />
            </label>
          </div>
          <label className="admin-field">
            <span>Días no trabajados</span>
            <input
              value={dias}
              inputMode="numeric"
              maxLength={1}
              placeholder="Días"
              disabled={bloqueadoDias}
              onChange={cambiarDias}
            />
          </label>
          <div className="admin-field">
            <span>Fechas de inasistencia</span>
            <div className="nomina-descuento-fecha">
              <input type="date" value={fecha} min={limites.min} max={limites.max} onChange={(event) => setFecha(event.target.value)} />
              <button type="button" className="admin-btn admin-btn--secondary" onClick={agregarFecha}>
                Agregar fecha
              </button>
            </div>
            {fechas.length > 0 ? (
              <ul className="nomina-descuento-fechas">
                {fechas.map((item) => (
                  <li key={item}>
                    <span>{fechaVisible(item)}</span>
                    <button type="button" onClick={() => setFechas(fechas.filter((actual) => actual !== item))} aria-label={'Quitar ' + item}>
                      ×
                    </button>
                  </li>
                ))}
              </ul>
            ) : null}
            <p className="admin-muted">
              Puedes agregar varias fechas con los mismos datos. Si solo registras un día, puedes guardar con la fecha del calendario.
            </p>
          </div>
          <label className="admin-field">
            <span>Concepto</span>
            <select
              value={tipoId}
              onChange={(event) => {
                setTipoId(event.target.value);
                setMotivo('');
              }}
            >
              <option value="">Seleccione el tipo de descuento</option>
              {tipos.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.descripcion}
                </option>
              ))}
            </select>
          </label>
          {esAusencia ? (
            <label className="admin-field">
              <span>Motivo de la ausencia</span>
              <input value={motivo} maxLength={255} onChange={(event) => setMotivo(event.target.value)} />
            </label>
          ) : null}
        </div>
        <p className="nomina-descuento-periodo">
          Información de nómina: Quincena: {textoQuincena} | Mes: {periodo.mes} | Año: {periodo.anio}
        </p>
        <div className="nomina-descuento-reporte">
          <span>Reporte PDF (quincena, mes y año)</span>
          <div>
            <select value={reporteQuincena} onChange={(event) => setReporteQuincena(event.target.value)}>
              <option value="1">Primera</option>
              <option value="2">Segunda</option>
            </select>
            <select value={reporteMes} onChange={(event) => setReporteMes(event.target.value)}>
              {MESES.map((mes) => (
                <option key={mes.id} value={mes.id}>
                  {mes.label}
                </option>
              ))}
            </select>
            <select value={reporteAnio} onChange={(event) => setReporteAnio(event.target.value)}>
              {aniosReporte().map((anio) => (
                <option key={anio} value={anio}>
                  {anio}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="nomina-descuentos-acciones">
          <button type="button" className="admin-btn admin-btn--primary" disabled={guardando} onClick={guardar}>
            {guardando ? 'Guardando…' : 'Guardar descuento'}
          </button>
          {empleadoId ? (
            <button type="button" className="admin-btn admin-btn--secondary" onClick={consultar}>
              Consultar descuento
            </button>
          ) : null}
          <button type="button" className="admin-btn admin-btn--secondary" onClick={reporte}>
            Generar reporte PDF
          </button>
          <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
            Salir
          </button>
        </div>
        {consultaAbierta ? (
          <div className="nomina-lista-blanca">
            {registros.length === 0 ? <p className="admin-muted">No hay descuentos para este empleado en la quincena en curso ni en la anterior.</p> : null}
            {registros.length > 0 ? (
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Horas</th>
                    <th>Días</th>
                    <th>Concepto</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {registros.map((item) => (
                    <tr key={item.id}>
                      <td>{fechaVisible(item.fecha)}</td>
                      <td>{item.horas}</td>
                      <td>{item.dias}</td>
                      <td>{item.concepto}{item.motivo ? ' (' + item.motivo + ')' : ''}</td>
                      <td>
                        <button type="button" className="admin-btn admin-btn--danger" onClick={() => eliminar(item.id)}>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NominaDescuentoHonorarios;
